import { initialState } from './selectors';
import { FOCUS_SET, FOCUS_CLEAR, FOCUS_MOVE } from './actions';

const moveFocus = ({ guestId, ...state }, { direction, guests }) => {
  const normalizedDirection = direction < 0 ? -1 : 1;
  const currentGuestIndex = guests.findIndex(id => id === guestId);
  const nextGuestIndex = (currentGuestIndex + guests.length + normalizedDirection) % guests.length;
  return {
    ...state,
    guestId: guests[nextGuestIndex],
  };
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FOCUS_SET:
      return {
        guestId: payload.guestId,
        field: payload.field,
        departureId: payload.departureId,
      };
    case FOCUS_CLEAR:
      return initialState;
    case FOCUS_MOVE:
      return moveFocus(state, payload);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/focus/reducer.js